export const curriculaPermissions = (actions: Set<string>) => {
  const CREATE_CURRICULUM = actions.has('create-curriculum')
  const EDIT_CURRICULUM = actions.has('edit-curriculum')

  return {
    CREATE_CURRICULUM,
    EDIT_CURRICULUM,
  } as const
}
